<template>
    <div>
        <AppBreadCrumb :paths="paths" :select="true" />
        <CustomerPlans :is-admin="false" :type="type" @go-back="goBack" />
    </div>
</template>
<script>
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import CustomerPlans from "./components/old/CustomerPlans.vue";

export default {
    name: "BillingPlans",
    components: {
        CustomerPlans,
        AppBreadCrumb,
    },
    data: () => {
        return {
            staticPaths: [
                {
                    title: "Fatura Yönetimi",
                    path: "/settings/billing",
                },
                { title: "Planlar" },
            ],
            paths: [],
            type: null,
            childPlans: false,
        };
    },
    mounted() {
        this.paths = _.cloneDeep(this.staticPaths);
        this.type = this.$route.params.type;
    },
    methods: {
        goBack() {
            this.$router.push({
                path: `/billing`,
            });
        },
    },
    watch: {
        "$route.params.type": {
            handler() {
                this.type = this.$route.params.type;
            },
        },
        type() {
            this.childPlans =
                ["supsis", "instagram"].find((type) => this.type?.includes(type)) && this.type?.endsWith("team");
        },
        childPlans() {
            this.paths = [...this.staticPaths];
            if (this.childPlans) {
                let type = (this.type || "").split("-");
                type = type.slice(0, type.length - 1);
                const title = type.map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase()).join(" ");
                this.paths.push({
                    title,
                    path: `/billing/plans/${type.join("-")}`,
                });
            }
        },
    },
};
</script>
